// @flow
import cond from 'ramda/es/cond';
import T from 'ramda/es/T';
import always from 'ramda/es/always';
import equals from 'ramda/es/equals';
import toLower from 'ramda/es/toLower';
import length from 'ramda/es/length';

import action from 'app/common/lib/action';
import api from 'app/actions/api';
import { errorCode } from 'app/common/lib/error';

/**
 * Проверка данных на существование при добавлении ребенка
 * (Не отражается в редюсере, кроме ошибок)
 */

export type Fields = {
  account_number: string,
  card_number: string,
}
export const ACCOUNT_IS_CARDNUM = 12;

export const CHECK_CHILD_REQUEST = 'CHECK_CHILD_REQUEST';
export const CHECK_CHILD_SUCCESS = 'CHECK_CHILD_SUCCESS';
export const CHECK_CHILD_FAILURE = 'CHECK_CHILD_FAILURE';

export const checkChild = (fields: Fields) => async (dispatch: Function): Promise<*> => {
  const params: Fields = { ...fields };
  dispatch(action(CHECK_CHILD_REQUEST, params));
  try {
    await api('cabinet/students/add/check', 'get', { params });
    dispatch(action(CHECK_CHILD_SUCCESS, params));
    return '';
  } catch (error) {
    const code: number = errorCode(error);
    const card = params.card_number;
    const account = params.account_number;
    const is1stField = (card && !account) || (card === account && length(card) === ACCOUNT_IS_CARDNUM);
    const title: string = is1stField ? 'Номер карты' : 'Номер счета';

    const text: string = cond([
      [equals(422), always('Введенная карта принадлежит сотруднику учебного заведения. Личный кабинет для родителей и их учащихся. Укажите пожалуйста номер карты учащегося.')],
      [equals(404), always(`${title} не найден`)],
      [T, always(`Не удалось проверить ${toLower(title)}, ошибка сервера`)],
    ])(code);

    dispatch(action(
      CHECK_CHILD_FAILURE, {
        err: text,
        error,
      }
    ));
    return text;
  }
};
